import { Navigate, Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import type { RoleName } from '../constants/roles';

interface RoleGuardProps {
  allow: readonly RoleName[];
  /** When provided, guards these children; otherwise acts as a layout route guarding <Outlet />. */
  children?: ReactNode;
}

/**
 * Role/capability guard (client-side, UX only). Redirects to /403 when the current user's role
 * is not in `allow`. Server-side policies remain the real access control (architecture §4.3, §8.2).
 */
export default function RoleGuard({ allow, children }: RoleGuardProps) {
  const { hasRole } = useAuth();

  if (!hasRole(allow)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children ?? <Outlet />}</>;
}
